import { createAsyncThunk } from "@reduxjs/toolkit";
import { ContType } from "common/type";
import axios from "./axios";

interface UpdateArticlePayload {
  articleId: number;
  data: any;
}

interface SaveArticleGroupPayload {
  formData: FormData;
  onProgress?: (percent: number) => void;
}

interface UpdateArticleGroupPayload {
  articleGroupId: number;
  data: any;
  onProgress?: (percent: number) => void;
}

export const getArticleGroups = createAsyncThunk('all/marketplace/article-groups/all', async () => {
  try {
    const response = await axios.get('/marketplace/article-groups')
    return response.data;
  } catch (error: any) {
    console.log(error?.message,'error', error);
  }
});

export const saveArticleGroup = createAsyncThunk('save/marketplace/article-groups/', async ({ formData, onProgress }: SaveArticleGroupPayload, thunkAPI) => {
  try {
    const response = await axios.post('/marketplace/article-groups/',formData, {
      onUploadProgress: (progressEvent) => {
        const percent = Math.round(
          (progressEvent.loaded * 100) / (progressEvent.total ?? 1)
        );
        if (onProgress) {
          onProgress(Math.min(percent, 90));
        }
      },
    })
    return response.data;
  } catch (error: any) {
    console.log(error?.message, 'error', error);
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const updateArticleGroup = createAsyncThunk('update/marketplace/article-groups/', async ({ articleGroupId, data, onProgress }: UpdateArticleGroupPayload, thunkAPI) => {
  try {
    const response = await axios.patch('/marketplace/article-groups/'+articleGroupId, data, {
      onUploadProgress: (progressEvent) => {
        const percent = Math.round(
          (progressEvent.loaded * 100) / (progressEvent.total ?? 1)
        );
        if (onProgress) {
          onProgress(Math.min(percent, 90));
        }
      },
    })
    return response.data;
  } catch (error: any) {
    console.log(error?.message, 'error', error);
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const deleteArticleGroup = createAsyncThunk('delete/marketplace/article-groups/', async (id: number|null, thunkAPI) => {
  try {
    const response = await axios.delete('/marketplace/article-groups/'+id)
    return response.data;
  } catch (error: any) {
    console.log(error?.message, 'error', error);
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const saveArticle = createAsyncThunk('save/marketplace/article', async (data: any, thunkAPI) => {
  try {
    const response = await axios.post('/marketplace/article',data)
    return response.data;
  } catch (error: any) {
    console.log(error?.message, 'error', error);
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const getArticles = createAsyncThunk('all/marketplace/article', async () => {
  try {
    const response = await axios.get('/marketplace/article')
    return response.data;
  } catch (error: any) {
    console.log(error?.message,'error', error);
  }
});

export const updateArticle = createAsyncThunk('update/marketplace/article', async ({ articleId, data }: UpdateArticlePayload, thunkAPI) => {
  try {
    const response = await axios.patch(`/marketplace/article/${articleId}`,data)
    return response.data;
  } catch (error: any) {
    console.log(error?.message, 'error', error);
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const deleteArticle = createAsyncThunk('delete/marketplace/article', async (id: number | null, thunkAPI) => {
  try {
    const response = await axios.delete(`/marketplace/article/${id}`)
    return response.data;
  } catch (error: any) {
    console.log(error?.message, 'error', error);
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});